<template>
  <ion-toolbar>
    <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length || routeName == 'profile_personal_cert' || stepCovid">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons v-if="(routeName != 'profile_personal_cert') && (routeName != 'onboard_personal_cert')" slot="end">
      <ion-button @click="skip" class="pill next-pill-button">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <div class="main_wrapper ion-padding ">
    <div class="container">
      <!-- <PageTitle :title="pageText.pageTitle" :subtitle="pageText.formText" /> -->
      <div class="auth-header">
                <div class="auth-heading">
                    <h1>Professional Certificate</h1>
                    <p class="auth-subtext">Please upload your documents!</p>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
    <div>
      <div class="text">
        Have you completed your immunisation training?
      </div>
      <br />

    </div>
    <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
      :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')">
      <div class="text" v-if="files.length <= 4">Upload your training certificates that apply</div>
      <el-form-item prop="documentType" v-if="files.length <= 4">
        <el-select v-model="formsData.userForm.type.value" class="m-2" placeholder="Select certificates type"
          size="large" @change="onChangeUpload">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="files.length <= 4">
        <div class="max-text"> (maximum upload - 5 file)</div>
        <el-upload class="uploader-support" :action="'upload'" :ref="(el) => (formsData.galleryForm.files.ref = el)"
          name="files" list-type="picture" :thumbnail-mode="true" :on-preview="cropperMethods.handlePreview" :limit="5"
          :on-exceed="cropperMethods.handleExceed" :drag="true" :on-change="cropperMethods.handleChange"
          :before-upload="cropperMethods.beforeAvatarUpload">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
         
          <template #file="{ file }">
                            <div v-if="file.raw.type == 'application/pdf'" class="el-upload-list__item-body">
                                <img class="el-upload-list__item-body-thumbnail"
                                    :src="require('@/assets/img/icons/pdf.svg')" />
                                <el-form-item prop="proofExpiryDate" class="mb-0" label="Policy Expiration date">
                                    <el-date-picker popper-class="datepicker_popper drawer-style" type="date" v-model="file.date" :format="$filters.systemDateFormat()"
                                        placeholder="Pick a date" @change="handleDateChange(file)"
                                        style="width: 100%;"></el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="el-upload-list__item-body" v-else>
                                <img class="el-upload-list__item-body-thumbnail" :src="file.url" alt="" />
                                <el-form-item prop="proofExpiryDate" class="mb-0" label="Policy Expiration date">
                                    <el-date-picker popper-class="datepicker_popper drawer-style" type="date" v-model="file.date" :format="$filters.systemDateFormat()"
                                        placeholder="Pick a date" @change="handleDateChange(file)"
                                        style="width: 100%;"></el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="el-upload-list__item-actions">
                                <button class="el-upload-list__item-actions-action"
                                    @click.stop.prevent="cropperMethods.handleRemove(file)">
                                    <img :src="require('@/assets/img/icons/trash.svg')" />
                                </button>
                            </div>
                        </template>
        </el-upload>
      </el-form-item>

      <el-form-item v-if="files.length <= 4" class="button_submit mb0">
        <el-button :disabled="disabled" class="submit" type="blue" @click="goNext('userForm')">
          <span v-if="routeName == 'profile_personal_cert'">Save </span>
          <span v-else>Continue </span>

        </el-button>
      </el-form-item>
      <div class="form_text" v-else>
        <div class="">
          You have uploaded the max number of certificates
        </div>
      </div>
    </el-form>
    <div class="bg-overlay"></div>
    <div class="preview_square preview_square-block preview_square-margin"
      v-if="files.length && routeName === 'profile_personal_cert'">
      <div class="proof-ins" v-if="immunisationFiles.length > 0">Immunisation Documents</div>
      <div class="el-upload-list">
        <div class="el-upload-list__item" v-for="(file) in immunisationFiles" :key="file.url">
          <div class="thumbnail_img el-upload-list--picture-card">
            <div v-if="file.extension == 'pdf'">
              <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
            </div>
            <div v-else>
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            </div>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="certPreviewModalOpen(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="fileDelete(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
          <div v-if="file.expiryDate">
            <div class="policy-expire">Expiration on:</div>
            <div class="expire-date">
              {{ file.expiryDate }}

            </div>
          </div>
        </div>
      </div>

      <div class="proof-ins" v-if="firstAidFiles.length > 0">First Aid and CPR Documents</div>
      <div class="el-upload-list">
        <div class="el-upload-list__item" v-for="(file) in firstAidFiles" :key="file.url">
          <div class="thumbnail_img el-upload-list--picture-card">
            <div v-if="file.extension == 'pdf'">
              <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
            </div>
            <div v-else>
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            </div>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="certPreviewModalOpen(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="fileDelete(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
          <div v-if="file.expiryDate">
            <div class="policy-expire">Expiration on:</div>
            <div class="expire-date">
              {{ file.expiryDate }}

            </div>
          </div>
        </div>
      </div>
      <div class="proof-ins" v-if="covidFiles.length > 0">Covid Documents</div>
      <div class="el-upload-list">
        <div class="el-upload-list__item" v-for="(file) in covidFiles" :key="file.url">
          <div class="thumbnail_img el-upload-list--picture-card">
            <div v-if="file.extension == 'pdf'">
              <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
            </div>
            <div v-else>
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            </div>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="certPreviewModalOpen(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="fileDelete(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
          <div v-if="file.expiryDate">
            <div class="policy-expire">Expiration on:</div>
            <div class="expire-date">
              {{ file.expiryDate }}

            </div>
          </div>
        </div>
      </div>
      <div class="proof-ins" v-if="oldProFiles.length > 0">Professional Documents</div>
      <div class="el-upload-list">
        <div class="el-upload-list__item" v-for="(file) in oldProFiles" :key="file.url">
          <div class="thumbnail_img el-upload-list--picture-card">
            <div v-if="file.extension == 'pdf'">
              <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
            </div>
            <div v-else>
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            </div>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="certPreviewModalOpen(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="fileDelete(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
          <div v-if="file.expiryDate">
            <div class="policy-expire">Expiration on:</div>
            <div class="expire-date">
              {{ file.expiryDate }}

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
  <cert-preview-modal :modalName="'certPreviewModal'" :options="certPreviewModal" />
</template>

<script>
import { onMounted, inject, ref, computed } from "vue";
import formHooks from "@/hooks/form/form";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import FileHelpers from "@/helpers/file/file";
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
import formValidate from "@/hooks/form/validate/validate";
import { useRouter, useRoute } from "vue-router";
import { CertPreviewModal } from "@/modals/modals";
// import PageTitle from "@/components/PageTitle/PageTitle.vue";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,
    "cert-preview-modal": CertPreviewModal,
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const moment = inject(["$moment"]);
    let stepCovid = ref(false);
    const routeName = $route.name;
    const BASE_URL = process.env.VUE_APP_BASEURL;
    const userData = $store.getters.GET_USER_DATA;
    console.log("🚀 ~ userData232323:", userData)
    const fileHelpers = new FileHelpers();
    const state = userData.address.state;
    let dialogVisible = true;
    let disabled = ref(true);
    const fileList = ref([]);
    const $modals = inject("$modals");
    const documentType = 1;
    const certPreviewModal = ref({
      name: "certPrev",
      file: [],
    });
    const certPreviewModalOpen = (file) => {
      if (file.extension == 'pdf') {
        window.open(file.url, '_blank');
      } else {
        certPreviewModal.value.file = file;
        $modals.open("certPreviewModal", {
          file: file,
        });
      }
    };
    const files = ref(userData.covidCertPro);
    const oldProFiles = computed(() => {
      return files.value.filter(item => item.subType === 0)
    })
    const immunisationFiles = computed(() => {
      return files.value.filter(item => item.subType === 1)
    })
    const firstAidFiles = computed(() => {
      return files.value.filter(item => item.subType === 2)
    })
    const covidFiles = computed(() => {
      return files.value.filter(item => item.subType === 3)
    })

    const pageText = {
      pageTitle: "Professional Certificate",
      formText: "Please upload your documents!",
    };

    const options = [
      {
        value: 1,
        label: 'Immunisation',
      },
      {
        value: 2,
        label: 'First Aid and CPR',
      },
      {
        value: 3,
        label: 'COVID',
      },
    ]

    const formsDataArray = {
      userForm: {
        files: {
          ref: null,
          value: [],
          limit: 10,
          disabled: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "gallery",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
        type: {
          value: documentType ? documentType : 1,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "documentType",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        proofExpiryDate: {
          ref: null,
          value: "",
        },
      },
    };
    // Object.assign(formsDataArray.userForm, formsDataArray);



    /** file handling function starts here */
    const handleDateChange = (file) => {
      const index = fileList.value.findIndex((f) => f.uid === file.uid);
      if (index === -1) {
        // Add new file to fileList if it does not already exist
        fileList.value.push(file);
      } else {
        // Update existing file's date value
        fileList.value[index].date = file.date;
      }
      console.log("change data", fileList.value);
    };

    const onChangeUpload = () => {
      if (formsData.userForm.files.value.length && formsData.userForm.type.value) {
        disabled.value = false;
      } else {
        disabled.value = true;
      }
    };

    const cropperMethods = {
      beforeAvatarUpload(file) {
        const img = URL.createObjectURL(file.raw);
        img
      },
      handleRemove(file) {
        formsData.userForm.files.splice(
          formsData.userForm.files.indexOf(file),
          1
        );
        // onChangeUpload();
      },
      handleChange(file, files) {
        const type = fileHelpers.getFileType(file);
        if (type == "image" || type == "pdf") {
          formsData.userForm.files = files;
          formsData.userForm.files.value = files;
          checkFormValidation("userForm", true, "files");
        } else {
          files.pop();
          formsData.userForm.files.value = null;
          ElMessage({
            type: "error",
            message: `Certificate   must be JPG JPEG PNG JFIF or PDF format!`,
          });
        }
        onChangeUpload();
      },

      handlePreview(/*file*/) { },
      handleExceed(file, files) {
        console.log(file);
        ElMessage({
          type: "error",
          message: `You can download 5 certificate, you selected ${files.length} `,
        });
      },
    };

    const goBack = async() => {
      if (stepCovid.value) {
        stepCovid.value = !stepCovid.value;
      } else if (routeName == "profile_personal_cert") {
        $router.push({
          name: "profile_documents",
        });
      } else {
        const back = await $store.dispatch("getAuthPageBack");
        $router.push({
            name: back,
        });
      }
    };

    const goNext = (formName) => {
      console.log('i am saving');
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          const canvas = formsData.userForm.files.value;
          console.log("🚀 ~ formsRefs[formName].value.validate ~ canvas:", canvas)
          const form = new FormData();
          let counter = 0;
          let counterOtherDate = 0;
          // let counterProof = 0;
          if (canvas.length != 0) {
            canvas.map((item) => {
              console.log(item);
              form.append(`covid_certs_pro[${counter}][file]`, item.raw);

              counter++;
            });
            if (fileList.value) {
              fileList.value.map((item) => {
                // form.append(`otherInsuranceFile[${counter}][file]`,  item.raw );
                form.append(`other_date[${counterOtherDate}]`, moment(item.date).format(
                  "YYYY-MM-DD"
                ));


                counterOtherDate++;
              });
            }
          } else {
            ElMessage({
              showClose: "true",
              type: "warning",
              message: routeName == "profile_personal_cert" ? " Please upload the file" : "Please upload a file or select SKIP",
            });
            console.log("error submit!!");
            return false;
          }
          console.log(form);
          form.append(`fileType`, formsData.userForm.type.value);
          (async () => {
            try {
              await $store.dispatch("SAVE_USER_DATA", form);

              if (routeName == "profile_personal_cert") {
                
                formsData.userForm.files.splice(0);
                
                const getUserData = $store.getters.GET_USER_DATA;
                
                files.value = getUserData.covidCertPro; 
                fileList.value = [];
                
                //  $router.push({
                //    name: "profile_personal_cert",
                //   //  name: "profile_documents",
                //  });
              } else if (routeName == "onboard_personal_cert") {
                $store.dispatch("ENABLE_MARKETPLACE_PROCESS_COMPLETE");
                $router.push({
                  name: "onboard_intro",
                });
              } else {
                $store.dispatch("SAVE_USER_DATA", {
                  survey: 1,
                  hideLoading: true,
                });
                $router.push({
                  name: "onboard_intro",
                });
              }

            } catch (error) {
              console.log("error submit", error);

              let item;
              for (item in error) {
                ElMessage({
                  showClose: "true",
                  type: "error",
                  message: error[item][0],
                });
              }
            }
          })();
        }
      });
    };

    const skip = () => {
      $store.dispatch("addAuthPageBack", $route.name);
      if (routeName == "onboard_personal_cert") {
        $store.dispatch("SAVE_USER_DATA", {
          survey: 1,
          hideLoading: true,
        });
        $router.push({
          name: "onboard_intro",
        });
      } else {
        $store.dispatch("SAVE_USER_DATA", {
          survey: 1,
          hideLoading: true,
        });
        $router.push({
          name: "intro",
        });
      }
    };



    const save = (formName, value) => {
      (async () => {
        try {
          const data = value
            ? getFormValues(formName)
            : {
              covid_cert: null,
            };
          await $store.dispatch("SAVE_USER_DATA", data);
          goBack();
        } catch (error) {
          console.log(error);
        }
      })();
    };

    const fileDelete = async (file) => {
      console.log("deleted file", file);
      try {
        await ElMessageBox.confirm(
          `Are you sure you’d like to remove file ?`,
          "Remove file",
          {
            confirmButtonText: "Remove",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--red",
            cancelButtonClass: "el-button--grey",
            showClose: false,
          }
        );
        await $store.dispatch("DELETE_USER_COVID_CERT", file);
        // files.value.splice(index, 1);
        // Find the index of the file in the computed property array
        // let computedIndex = -1;
        // switch (type) {
        //   case "immunisationFiles":
        //     computedIndex = immunisationFiles.value.findIndex((item) => item === file);
        //     break;
        //   case "firstAidFiles":
        //     computedIndex = firstAidFiles.value.findIndex((item) => item === file);
        //     break;
        //   case "covidFiles":
        //     computedIndex = covidFiles.value.findIndex((item) => item === file);
        //     break;
        //   default:
        //     break;
        // }

        files.value = files.value.filter(item => file.id != item.id);


        // if (computedIndex !== -1) {
        //   // Remove the file from the computed property array
        //   console.log("computers index", computedIndex);
        //   switch (type) {
        //     case "immunisationFiles":
        //       immunisationFiles.value.splice(computedIndex, 1);
        //       break;
        //     case "firstAidFiles":
        //       firstAidFiles.value.splice(computedIndex, 1);
        //       break;
        //     case "covidFiles":
        //       covidFiles.value.splice(computedIndex, 1);
        //       break;
        //     default:
        //       break;
        //   }
        // }

      } catch (error) {
        console.log(error);
      }
    };

    const {
      checkFormValidation,
      setFormValidation,
      formsRefs,
      setFormRefs,
      getFormValues,
      formsData,
    } = formHooks(formsDataArray);

    onMounted(() => {
      setPageClassGlobal("global_auth_page");
      checkFormValidation("userForm", false);
      setFormRefs();
    });


    return {
      formsData,
      goBack,
      skip,
      goNext,
      checkFormValidation,
      routeName,
      cropperMethods,
      fileDelete,
      stepCovid,
      files,
      state,
      BASE_URL,
      getFormValues,
      save,
      certPreviewModalOpen,
      certPreviewModal,
      dialogVisible,
      disabled,
      onChangeUpload,
      options,
      handleDateChange,
      fileList,
      immunisationFiles,
      firstAidFiles,
      covidFiles,
      oldProFiles,
      pageText,
    };
  },
};
</script>
